// API Configuration
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:9234/api'

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/admin/staff/login',
    OWNER_LOGIN: '/admin/login-owner',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    STAFF_UPDATE_PASSWORD: '/admin/staff-update-password',
  },
  USER: {
    PROFILE: '/admin/staff/profile',
    OWNER_PROFILE: '/admin/profile',
    ALL_DETAILS: '/admin/users/all-details',
    CREATE_STAFF: '/admin/staff/create-staff',
    CREATE_USER_UNDER_PARENT: '/admin/users/create-under-parent',
  },
  LORDS: {
    UPDATE_CURRENT: '/lords/update-current',
    NET_EXPOSURE: '/lords/net-exposure',
    BET_LIST: '/lords/bet-list',
    BET_TICKER: '/lords/bet-ticker',
    // New Granular Endpoints
    UPDATE_CREDIT_LIMIT: '/lords/user-setting/credit-limit',
    UPDATE_EXPOSURE_LIMIT: '/lords/user-setting/exposure-limit',
    UPDATE_STATUS: '/lords/user-setting/status',
    UPDATE_PASSWORD: '/lords/user-setting/update-password',
    TRANSFER: '/lords/transfer',
    STATEMENT: '/lords/transfer/statement',
  },
  CASINO: {
    LAST_RESULTS: '/casino/casino/last-results',
  },
  REPORTS: {
    CURRENT_BETS: '/admin/reports/current-bets',
    GAME_REPORT: '/admin/reports/game-report',
  },
  TABLE_CASINO: {
    LIST: '/admin/table-casino/list',
    LOCKS: '/admin/table-casino/locks',
    LOCK: '/admin/table-casino/lock',
  },
  SPORTS_DATA: '/user/cricket/all-data',
  GET_SPORTS_TREE: '/user/all/sports/tree',
  GET_SPORT_DATA: '/user/cricket/all-data',
  GET_MATCH_PRIVATE_DATA: '/user/cricket/get-match-private-data',
  GET_SPORTS_SCORE_CARD: '/user/cricket/score-card',
  WALLET_STATEMENT: '/transfer/wallet/statement',
  CLIENT_WALLET_STATEMENT: '/transfer/client/wallet/statement',
  SEARCH_BY_USERNAME: '/admin/search-by-username',
  INTERNALSETTLE: {
    MOMATCHES: '/internalsettle/momatches',
    FANMATCHES: '/internalsettle/fanmatches',
    DECLARERESULT: '/internalsettle/declareresult',
    VOID: '/internalsettle/void',
    OPEN_BETS: '/internalsettle/open-bets',
    VOID_SINGLE_BET: '/internalsettle/void-single-bet',
    SETTLED_MARKETS: '/internalsettle/settled-markets',
    SETTLED_BETS: '/internalsettle/settled-bets',
    VOID_MARKET_AFTER_SETTLEMENT: '/internalsettle/void-market-after-settlement',
    VOID_BET_AFTER_SETTLEMENT: '/internalsettle/void-bet-after-settlement',
  },
}
